"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var date_fns_1 = require("date-fns");
var wildfires_1 = require("../../store/reducers/wildfires");
var UI_1 = require("../../store/reducers/UI");
var __1 = require("..");
var ListViewContainer = function () {
    var dispatch = react_redux_1.useDispatch();
    var visibleFeatures = react_redux_1.useSelector(wildfires_1.visibleFeaturesSelector);
    var activeListMode = react_redux_1.useSelector(UI_1.listModeSelector);
    var searchTerm = react_redux_1.useSelector(UI_1.searchTermSelector);
    var onClickHandler = function (feature) {
        dispatch(wildfires_1.updateWildfireFeature2FlyTo(feature));
    };
    var onHoverHandler = function (feature) {
        dispatch(wildfires_1.updateWildfireFeature2OpenPopup(feature));
    };
    var getTimelineData = function () {
        if (!visibleFeatures.length) {
            return [];
        }
        var currDate = new Date();
        var distinctLabel = {};
        var features = getFeatures()
            .filter(function (feature) {
            return feature && date_fns_1.differenceInDays(currDate, new Date(feature.attributes.FireDiscoveryDateTime)) <= 180;
        })
            .sort(function (a, b) {
            return b.attributes.FireDiscoveryDateTime - a.attributes.FireDiscoveryDateTime;
        });
        var timelineData = features.map(function (feature) {
            var discoveryDate = new Date(feature.attributes.FireDiscoveryDateTime);
            var formattedDay = date_fns_1.format(discoveryDate, 'MMM do');
            var formattedMonth = date_fns_1.format(discoveryDate, 'MMMM');
            var dayLabel = !distinctLabel[formattedDay] ? formattedDay : '';
            distinctLabel[formattedDay] = true;
            var monthLabel = !distinctLabel[formattedMonth] ? formattedMonth : '';
            distinctLabel[formattedMonth] = true;
            var data = {
                feature: feature,
                dayLabel: dayLabel,
                monthLabel: monthLabel,
            };
            return data;
        });
        return timelineData;
    };
    var getGridData = function () {
        var features = getFeatures();
        return features.sort(function (a, b) {
            return b.attributes.DailyAcres - a.attributes.DailyAcres;
        });
    };
    var getFeatures = function () {
        var features = !searchTerm || searchTerm.length < 3
            ? __spreadArrays(visibleFeatures) : __spreadArrays(visibleFeatures).filter(function (d) {
            var fireName = d.attributes.IncidentName.toLowerCase();
            var matchString = searchTerm.toLowerCase();
            return fireName.indexOf(matchString) > -1;
        });
        return features;
    };
    var getList = function () {
        if (!visibleFeatures.length) {
            return null;
        }
        return activeListMode === 'timeline'
            ? React.createElement(__1.TimeLine, { data: getTimelineData(), onClick: onClickHandler, onHoverHandler: onHoverHandler })
            : React.createElement(__1.GridList, { data: getGridData(), onClick: onClickHandler, onHoverHandler: onHoverHandler });
    };
    return getList();
};
exports.default = ListViewContainer;
